export default __webpack_public_path__ + "static/media/Krutik_Resume.97a1d729.pdf";